import map from '../shared/view-product-map'

export default {
  loaded() {
    map()
  }
};
